import React from "react";
import { useDispatch, useSelector } from 'react-redux';

import { updateMsaPhase } from '../../../redux/reducers/filtersReducer';
import { msaPhaseSelector } from '../../../redux/selectors/filtersSelectors';
import Image from '../../UI/Image/Image';
import variables from "../../../styles/variables";

import {
  PhaseWrapper,
  MobilistWrapper,
  MessageBox,
  Message,
  CTAButton,
} from './styles';

interface Props {
  msaData: Record<string, any>;
  resetFilters:React.Dispatch<React.SetStateAction<void>>;
}
const BeginMSA = ({ msaData, resetFilters }:Props) => {
  const msaPhase = useSelector(msaPhaseSelector);
  const dispatch = useDispatch();
  // Change to phase 1 to initialize MSA flow
  const phaseHandler = () => {
    if (msaPhase === 0) {
      resetFilters();
    }
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'getStarted',
      });
    }
    dispatch(updateMsaPhase(msaPhase + 1));
  };

  return (
    <PhaseWrapper
      $backgroundColor={variables.colorWhite}
    >
      <MobilistWrapper>
        <Image image={msaData.progressImage} isImageDecorative data-testid="search-image" />
      </MobilistWrapper>
      <MessageBox>
        <Message data-testid="heading">{msaData.dialogueText}</Message>
      </MessageBox>
      <CTAButton
        buttonColor={msaData.stepCtas[0].ctaColor}
        buttonSize="medium"
        onClick={phaseHandler}
        data-testid="cta-get-started"
      >
        {msaData.stepCtas[0].ctaLabel.ctaLabel}
      </CTAButton>
    </PhaseWrapper>
  );
};

export default BeginMSA;
